import { Directive, ElementRef, Input, NgZone, OnDestroy, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[resizeColumn]'
})
export class ResizeColumnDirective implements OnInit, OnDestroy {

    @Input("resizeColumn") resizable: boolean;

    @Input() index: number;

    private startX: number;

    private startWidth: number;

    private column: HTMLElement;

    private table: HTMLElement;

    // Funciones para remover los listeners registrados con renderer.listen
    private unlistenMouseDown?: () => void;
    private unlistenDrag: Array<() => void> = [];

    constructor(private renderer: Renderer2, private el: ElementRef, private zone: NgZone) {
        this.column = this.el.nativeElement;
    }

    ngOnInit() {
        if (this.resizable) {
        const row = this.renderer.parentNode(this.column);
        const thead = this.renderer.parentNode(row);
        this.table = this.renderer.parentNode(thead);
        const resizer = this.renderer.createElement("span");
        this.renderer.addClass(resizer, "resize-holder");
        this.renderer.appendChild(this.column, resizer);
        // Fuera de la zona de Angular: el redimensionado solo toca estilos del DOM,
        // así que no necesita disparar detección de cambios en cada evento del mouse.
        this.zone.runOutsideAngular(() => {
            this.unlistenMouseDown = this.renderer.listen(resizer, "mousedown", this.onMouseDown);
        });
        }
    }

    ngOnDestroy() {
        this.unlistenMouseDown?.();
        this.stopDrag();
    }

    private onMouseDown = (event: MouseEvent) => {
        this.startX = event.pageX;
        this.startWidth = this.column.offsetWidth;
        // mousemove y mouseup solo se escuchan mientras se arrastra la columna
        this.stopDrag();
        this.unlistenDrag = [
            this.renderer.listen(this.table, "mousemove", this.onMouseMove),
            this.renderer.listen("document", "mouseup", this.onMouseUp),
        ];
    };

    private onMouseMove = (event: MouseEvent) => {
        const offset = 35;
        if (event.buttons) {
            this.renderer.addClass(this.table, "resizing");
            // Calculate width of column
            let width = this.startWidth + (event.pageX - this.startX -  offset);
            const tableCells = Array
            .from(this.table.querySelectorAll(".mat-row"))
            .map((row: any) => row.querySelectorAll(".mat-cell")
            .item(this.index));
            // Set table header width
            this.renderer.setStyle(this.column, "width", `${width}px`);
            // Set table cells width
            for (const cell of tableCells) {
            this.renderer.setStyle(cell, "width", `${width}px`);
            }
        }
        };


    private onMouseUp = () => {
        this.renderer.removeClass(this.table, "resizing");
        this.stopDrag();
    };

    private stopDrag() {
        this.unlistenDrag.forEach(unlisten => unlisten());
        this.unlistenDrag = [];
    }

}
